import AjaxBuilder from "../../../../Common/AjaxBuilder";
import { Loader } from "../../../CommonComponents/Insurance/Loader";

export class CalculateInsurance {
    constructor({ insuranceForm, state }) {
        this.$form = insuranceForm;
        this._state = state;

        this._route = this.$form.attr('action');
        this.$priceBlock = this.$form.find('span.price');
    }

    calculateInsurance() {
        if(!this._state.franchise 
        || !this._state.city 
        || !this._state.category ) return false;

        Loader.showLoader(this.$form);

        new AjaxBuilder({
            route: this._route,
            data: {
                franchise: this._state.franchise.franchise,
                city_id: this._state.city.value,
                category: this._state.category.value,
            },
        }, 'GET').execute({
            success: this._calculateInsuranceSuccess.bind(this),
            error: this._calculateInsuranceError.bind(this),
        });
    }

    _calculateInsuranceSuccess(data) {
        this._state.price = data.response.payment;
        this._state.tariff = data.response.tariff.id;
        
        this.$priceBlock.html(`${this._state.price.toFixed(2)} грн`);
        
        Loader.hideLoader(this.$form);
    }

    _calculateInsuranceError(data) {

    }

}